<template>
    <div id="demo-basic-card" class="margin-top-voice">
        <div id="dashboard-analytics">
            <div class="vx-row">
                <div class="vx-card p-2 pt-0">
                    <div class="vx-row">
                        <div class="vx-col w-full md:w-3/12 m-auto mt-4">
                            <span class="font-medium">Share of Voice</span>
                            <span class="badge ml-2 bg-danger text-white">Beta</span>
                        </div>
                        <div class="vx-col w-full md:w-7/12 mt-2 flex">
                            <div class="vx-row ml-auto">
                                <div class="component m-2">
                                    <span class="font-medium">Khoảng thời gian:</span>
                                </div>
                                <date-range-picker
                                    ref="picker"
                                    :locale-data="{ format: 'dd/mm/yyyy' }"
                                    :opens="'left'"
                                    @update="refundData"
                                    v-model="dateRange">
                                </date-range-picker>
                            </div>
                        </div>
                        <div class="vx-col w-full md:w-2/12 mt-2">
                            <!-- <vs-button class="ml-auto" icon-pack="feather" icon="icon-download">Báo cáo</vs-button> -->
                        </div>
                    </div>
                </div>

                <div class="vx-card p-2 pt-0 mt-3">
                    <div class="vx-row">
                        <div class="vx-col w-full md:w-2/12 mt-2 buttonSelect" v-for="(selectedButton, index) in optionalSelected" :key="index">
                            <div v-if="selectedButton" class="btn-selected w-full cursor-pointer" :style="{background: selectedButton.bg, color: selectedButton.color}" >
                                <div class="button-topic w-full" @click="openSlideBar(selectedButton, index)">
                                    <span class="cursor-pointer ml-2">{{selectedButton.label}}</span>
                                </div>
                                <div class="md:w-1/6 text-center flex text-selected" v-if="selectedButton.selected" @click="removeButton(selectedButton, index)">
                                    <feather-icon icon="XIcon" class="icon-delete-button cursor-pointer"></feather-icon>
                                </div>
                            </div>
                        </div>

                        <div class="md:w-1/12 w-full text-center mt-2 ml-2 cursor-pointer text-primary" @click="addNewSelected">
                            <feather-icon class="add-new-selected mr-1" icon-pack="feather" icon="PlusIcon"></feather-icon>
                            <span class="font-medium">THÊM MỚI</span>
                        </div>
                    </div>
                </div>

                <div class="vx-card p-2 pt-0 mt-3" style="min-height:38px"> 
                    <div class="vx-row">
                        <div class="vx-col w-full mt-2" style="max-width:120px" v-for="(selectedButton, index) in optionalSelected" :key="index">
                            <div class="w-full cursor-pointer flex" v-if="selectedButton.selected">
                                <div class="h-3 w-3 rounded-full mt-1" :style="{background: selectedButton.circle}"></div>
                                <div class="w-full button-topic text-left">
                                    <span class="cursor-pointer ml-2">{{selectedButton.label}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <vs-sidebar click-not-close hidden-background position-right v-model="active" class="items-no-padding">
                <div class="header-sidebar w-full" slot="header" style="display: flex;justify-content: space-between;">
                <span class="font-medium ml-4">Chọn để so sánh</span>
                <feather-icon class="cursor-pointer" style="width:1rem" icon="XIcon" @click="active= false"></feather-icon>
                </div>
                <div class="vx-col w-full ml-4">
                <div class="vx-col mr-2"  >
                    <VuePerfectScrollbar
                    style="max-height: 635px;"
                    class="scroll-area--nofications-dropdown p-0"
                    :settings="settings"
                    >
                    <vs-collapse accordion>
                        <vs-collapse-item v-for="(group, index) in optionGroupTopics" v-bind:key="index">
                        <div slot="header">
                            <div class="vx-row">
                            <div class="component mt-1">
                                <vs-checkbox v-model="group.checkedGroup" @click="selectedGroup(group)"></vs-checkbox>
                            </div>
                            <div v-if="group.color" class="color-group mt-0 p-0 text-center text-white mt-1"
                                :style="{background:group.color}">
                            </div>
                            <div v-else class="color-group mt-0 p-0 text-center text-white mt-1"
                                style="background-color:rgba(var(--vs-primary), 1)">
                            </div>
                            <span class="ml-2 mt-1 font-bold" style="font-size: 14px;color:  rgb(94 88 115)">{{ group.label }}</span>
                                <span v-if="group.color" class="badge ml-2 mt-1 text-white" :style="{background: group.color, height: '1.5rem'}">{{ countTopic(group) }}</span>
                                <span v-else class="badge mt-1 ml-2 bg-primary text-white" style="height:1.5rem">{{ countTopic(group) }}</span>
                            </div>
                        </div>
                        <div class="topic cursor-auto">
                            <div class="vx-row w-full p-3 cursor-pointer" style="font-size: 16px"
                                v-for="(item, index) in listTopics.filter(el => el.topicGroupId == group.value)"
                                :key="index">
                                <div class="component">
                                    <vs-checkbox v-model="item.checked" @click="selectedTopic(item)"></vs-checkbox>
                                </div>
                                <div class="md:w-5/6 pr-6">
                                    <feather-icon
                                    icon="GridIcon"
                                    class="ml-2 align-feather"
                                    >
                                    </feather-icon>
                                    <span class="ml-2 font-medium" style="font-size: 14px">{{ item.topicName }}</span>
                                </div>
                            </div>
                        </div>
                        </vs-collapse-item>
                        <vs-collapse-item>
                        <div slot="header">
                            <div class="vx-row">
                            <!-- <div class="count-other text-white text-center"></div> -->
                            <div class="component">
                                <vs-checkbox v-model="checkboxOther" @click="selectedCheckboxOther()"></vs-checkbox>
                            </div>
                            <span class="ml-1 mt-1 ml-2 font-bold"
                                    style="font-size: 15px;color:  rgb(94 88 115)">{{
                                $t('projectAndTopic.otherTopics')
                                }}</span>
                            <span class="badge mt-1 ml-2 bg-primary text-white" style="height:1.5rem">{{ countTopicOther() }}</span>
                            </div>
                        </div>
                        <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown p-0"
                                            :settings="settings" style="max-height: 18rem">
                            <div class="topic cursor-auto text-overflow">
                            <div class="vx-row w-full p-3  cursor-pointer" style="font-size: 14px"
                                v-for="(item, index) in listTopics.filter(el => el.isOther)"
                                :key="index">
                                <div class="component">
                                    <vs-checkbox v-model="item.checked" @click="selectedTopicOther(item)"></vs-checkbox>
                                </div>
                                <div class="md:w-5/6 pr-6">
                                <feather-icon
                                    icon="GridIcon"
                                    class="ml-2 align-feather"
                                >
                                </feather-icon>
                                <span class="ml-2 font-medium" style="font-size: 14px">{{ item.topicName }}</span>
                                </div>
                            </div>
                            </div>
                        </VuePerfectScrollbar>
                        </vs-collapse-item>
                    </vs-collapse>
                    </VuePerfectScrollbar>
                </div>
                </div>
                <div class="w-full align-bottom">
                    <div class="w-full text-center">
                        <vs-button @click="refreshDataTopic">{{ $t('shareOfVoice.update')}}</vs-button>
                        <vs-button class="ml-4" type="border" @click="active = false" style="z-index:1000 !important"> {{$t('button.closed')}}</vs-button>
                        <vs-button type="border" class="ml-4" @click="unChecked">{{ $t('shareOfVoice.unChecked') }}</vs-button>
                    </div>
                </div>
            </vs-sidebar>
            <news :dateRange="dateRange" :refreshData="refresh" :topics="arrTopicBinding"></news>
            <mentioned :dateRange="dateRange" :refreshData="refresh" :topics="arrTopicBinding"></mentioned>
            <shades :dateRange="dateRange" :refreshData="refresh" :topics="arrTopicBinding"></shades>
            <gender :dateRange="dateRange" :refreshData="refresh" :topics="arrTopicBinding"></gender>
            <!-- <ages></ages> -->
        </div>
    </div>
</template>

<script>
import DateRangePicker from "@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

import news from './chart-share-of-voice/News.vue';
import mentioned from './chart-share-of-voice/Mentioned.vue';
import shades from './chart-share-of-voice/Shades.vue';
import gender from './chart-share-of-voice/Gender.vue';
import ages from './chart-share-of-voice/Ages.vue';
export default {
    components: {
        DateRangePicker,
        VuePerfectScrollbar,
        news,
        mentioned,
        shades,
        gender,
        ages
    },
    data(){
        return {
            active: false,
            checkboxOther: false,
            refresh: null,

            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .30,
                suppressScrollX: true,
            },
            //topic
            listTopics: [],
            optionGroupTopics: [],

            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                let date = new Date();
                date.setDate(date.getDate() - 6);
                date.setHours(0, 0, 0);
                return date;
                })()
            },
            optionalSelected: [],
            arrTopic: [],
            arrTopicBinding: [],
            arrTopicGroup: []
        }
    },
    computed: {
    },
    methods: { 
        refundData: function(){
            this.refresh += 1;
        },
        removeButton: function(event, index){
            this.removeTopicIdInArr(event.id);
            this.removeOptionSelected(index);
            this.listTopics = this.listTopics.map(el => {
                if (el.id == event.id) el.checked = false;
                return el;
            });
            if (event.isOther) this.resetCheckedGroupOther(event);
            else this.resetCheckedGroup(event);
            this.refresh +=1 ;
            this.arrTopicBinding = this.arrTopic;
        },
        unChecked: function(){
            this.resetChecked();
        },
        resetChecked: function(){
            this.optionGroupTopics = this.optionGroupTopics.map(el => {
                el.checkedGroup = false;
                return el;
            })
            this.checkboxOther = false;
            this.arrTopic = [];
            this.initScreen();
            this.active = true;

        },
        resetCheckedGroup: function(event){
            let topicGroupId = event.topicGroupId;
            let countTopicChecked = this.listTopics.filter(el => el.topicGroupId == event.topicGroupId);
            let countChecked = countTopicChecked.filter(el => el.checked).length;
            let countUnChecked = countTopicChecked.filter(el => !el.checked).length;
            if (countUnChecked === 0){
                this.optionGroupTopics.forEach(el => {
                    if (el.value == topicGroupId) {
                        setTimeout(()=>{
                            el.checkedGroup = true;
                        }, 200)
                    } 
                })
            }
            else if(countChecked === 0) {
                this.optionGroupTopics.forEach(el => {
                     if (el.value == topicGroupId) {
                         setTimeout(()=>{
                            el.checkedGroup = false;
                        }, 200)
                     }
                })
            }
        },
        resetCheckedGroupOther: function(event){
            let countTopicChecked = this.listTopics.filter(el => el.isOther);
            let countChecked = countTopicChecked.filter(el => el.checked).length;
            let countUnChecked = countTopicChecked.filter(el => !el.checked).length;
            if (countChecked === 0) {
                setTimeout(() => {
                   this.checkboxOther = false; 
                }, 200);
            }
            else if(countUnChecked === 0){
                setTimeout(() => {
                   this.checkboxOther = true; 
                }, 200);
            }
        },
        addNewSelected: function(){
            let object = {
                id : null,
                label: 'Chọn',
                bg: '#EBE9F1',
                color: '#6E6B7B',
                selected: false,
                circle:'#007AFE',
                topicGroupId: null
            }
            this.optionalSelected.push(object);
        },
        activeSlideBar: function(){
            this.active = true;
        },
        refreshDataTopic: function(){
            this.arrTopic = [];
            let data = this.listTopics.filter(el => el.checked)
            data = data.map(el => { 
                if (el) this.pushTopicIdToArr(el.id);
                return {
                    id : el.id,
                    label: el.topicName,
                    bg: '#5E5873',
                    color: '#EBE9F1',
                    selected: true,
                    circle: el.color ? el.color : '#007AFE',
                    topicGroupId: el.topicGroupId,
                    isOther: el.isOther
                }
            })
            this.optionalSelected = data;
            this.refresh += 1;
            this.arrTopicBinding = this.arrTopic;
            this.active = false;
        },
        pushTopicIdToArr: function(topicId){
            this.arrTopic.push(topicId);
        },
        removeTopicIdInArr: function(topicId){
            const index = this.arrTopic.indexOf(topicId);
            if (index >= -1) this.arrTopic.splice(index, 1);
        },
        removeOptionSelected: function(index){
            this.optionalSelected.splice(index, 1);
        },
        selectedCheckboxOther: function(){
            let result = [];
            if (!this.checkboxOther){
                result = this.listTopics.map(el => {
                    if (el.isOther) {el.checked = true; this.pushTopicIdToArr(el.id);}
                    return el;
                })
            }else {
                result = this.listTopics.map(el => {
                    if (el.isOther) {el.checked = false; this.removeTopicIdInArr(el.id);}
                    return el;
                })
            }
            this.listTopics = result;
        },
        selectedGroup: function(event){
            let result = [];
            if (!event.checkedGroup){
                result = this.listTopics.map(el => {
                    if (event.value == el.topicGroupId && event.color) {el.checked = true; el.color = event.color; this.pushTopicIdToArr(el.id)}
                    else if(event.value == el.topicGroupId) {el.checked = true; this.pushTopicIdToArr(el.id);}
                    return el;
                })
            }else {
                result = this.listTopics.map(el => {
                    if (event.value == el.topicGroupId) {el.checked = false; this.removeTopicIdInArr(el.id)};
                    return el;
                })
            }
            this.listTopics = result;
        },
        selectedTopic: function(event){
            event.checked = !event.checked;
            this.resetCheckedGroup(event);
        },
        selectedTopicOther: function(event){
            event.checked = !event.checked;
            this.resetCheckedGroupOther(event);
        },
        countTopic: function(group){
            let count = this.listTopics.filter(el => el.topicGroupId == group.value).length;
            return count;
        },
        countTopicOther: function(){
            let count = this.listTopics.filter(el => el.isOther).length;
            return count;
        },
        openSlideBar: function(item, index){
            this.active = true;
        },
        getTopicGroups: function(){
            return new Promise((resolve,reject) =>{
                this.$business.post('/topic-group/find-by-conditions',{}).then((res) =>{
                this.optionGroupTopics = res.data;
                if(this.optionGroupTopics.length > 0){
                    this.optionGroupTopics = this.optionGroupTopics.map(el =>{
                    return {
                        label:el.groupName,
                        value:el.id,
                        color:el.color,
                        checkedGroup: false
                    }
                    })
                }
                resolve();
                }).catch(() => reject())
            })
        },
        getTopic: function(){
            this.$business.post(`topic/find-by-conditions`,{}).then((res) =>{
                this.$business.post(`share-topic/get-all-share`, {}).then((topicShareRes) =>{
                    let data = this.listTopics = [...res.data,...topicShareRes.data.filter(item => item.status === 1)];
                    data = data.map(item => {
                        item.isOther = true;
                        if (this.optionGroupTopics.find(group => {
                            return group.value == item.topicGroupId
                        })) {
                        item.isOther = false;
                        }
                        item.checked = false;
                        return item;
                    });
                    this.listTopics = data;
                })
            })
        },
        initScreen(){
            this.active = false;
            this.getTopicGroups().then(() =>{
                this.getTopic();
            });
        }
    },
    async created(){
        this.initScreen();
    }
}
</script>

<style lang="scss">
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}
.daterangepicker {
  border-left: none !important;
}
@media (max-width: 1440px) {
  .statistic {
    padding: 0 !important;
  }
}
.badge {
    padding: .3rem .5rem;
    text-align: center;
    border-radius: .7rem;
    font-weight: 400 !important;
}
.bg-button {
    background: rgba(var(--vs-secondary),1)!important;
    color: #EBE9F1;
}
.btn-selected{
  height: 28px;
  border-radius: 5px;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.button-topic{
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.text-selected {
    color: #EBE9F1;
}
.icon-delete-button {
    width: 1rem;
}
.add-new-selected {
    vertical-align: bottom;
    width: 1rem;
}
.reportrange-text {
    border-radius: 10px;
    min-width: 200px;
}
.margin-top-voice {
    margin-top: -20px;
}
.color-group {
  margin-top: 2px;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  font-size: 12px;
}
.align-bottom {
    position: absolute;
    bottom: 10px;
}
.align-feather {
    width: 1rem;
    height: 1rem;
    vertical-align: middle;
}
.button-selected {
    background: #EBE9F1;
    color: #6E6B7B
}
#dashboard-analytics {
    .vs-sidebar {
        position: fixed;
        width: 400px;
        z-index: 99999 !important;
        max-width: 90vw;
        // @apply shadow-lg;
        box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
    }
}
</style>